import 'react-perfect-scrollbar/dist/css/styles.css';
import 'nprogress/nprogress.css';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { bootWithLatestVersion } from 'src/serviceWorkerRegistration';
import store from 'src/store';
import { SettingsProvider } from 'src/contexts/SettingsContext';
import App from 'src/App';

// Nothing interactive renders until the boot gate confirms this page runs the
// latest deployed build. If a newer one is found the page reloads into it
// instead — the static splash in index.html stays on screen throughout.
bootWithLatestVersion().then(() => {
  ReactDOM.render(
    <Provider store={store}>
      <SettingsProvider>
        <App />
      </SettingsProvider>
    </Provider>,
    document.getElementById('root')
  );
});
